module.exports = __webpack_public_path__ + "img/active-companies.03d2f421.svg";